import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import TicketVendingMachineSettingsPage from "../TicketVendingMachine";
import GeneralSettingsPage from "../General";
import ClosedPeriodsSettingsPage from "../ClosedPeriods";

const BusinessSettingsPage = () => {
  const { t } = useTranslation("dashboard");
  const location = useLocation();
  const history = useHistory();
  const { url } = useRouteMatch();

  const pathParts = location.pathname.split("/");
  const lastPathPart = pathParts[pathParts.length - 1];
  const activeTab = ["business", "smart-checkout"].includes(lastPathPart)
    ? "general"
    : lastPathPart || "general";

  function handleTabSelect(key) {
    history.push(`${url}/${key}`);
  }

  return (
    <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
      <Tab title={t("settings.business.general.title")} eventKey={"general"}>
        {activeTab === "general" && <GeneralSettingsPage />}
      </Tab>
      <Tab
        title={t("settings.business.ticket_vending_machine.title")}
        eventKey={"ticket-vending-machine"}
      >
        {activeTab === "ticket-vending-machine" && (
          <TicketVendingMachineSettingsPage />
        )}
      </Tab>
      <Tab
        title={t("settings.business.closed_periods.title")}
        eventKey={"closed-periods"}
      >
        {activeTab === "closed-periods" && <ClosedPeriodsSettingsPage />}
      </Tab>
    </Tabs>
  );
};

export default BusinessSettingsPage;
